export const animateHorizontalIndicator = (props: {
  container: HTMLElement | null;
  items: NodeListOf<Element>;
  indicator: HTMLElement | null;
}) => {
  const { container, items, indicator } = props;

  if (container && indicator) {
    items.forEach(item => {
      item.addEventListener('mouseenter', () => {
        const rect = item.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const targetLeft = rect.left - containerRect.left;
        const targetWidth = rect.width;

        indicator.style.width = `${targetWidth}px`;

        indicator.style.transition = 'none';
        indicator.style.transform = `translateX(${targetLeft}px)`;

        indicator.style.transition = 'transform 0.5s cubic-bezier(0.25, 1.5, 0.5, 1)';
        indicator.style.transform = `translateX(${targetLeft}px)`;
      });
    });

    container.addEventListener('mouseleave', () => {
      if (!Array.from(items).some(item => item.classList.contains('active'))) {
        indicator.style.width = `0`;
      }
    });
  }
};
